// @ vendor
const React = require('react');

// @ utilities
const { getLastNChars } = require('utilities/stringHelper');
const { formatText } = require('core/i18n').i18n;

// @ constants
const { FOURTH_STEP } = require('constants/index');

const insuranceRequestBuildAccount = (immAccounts, immInsuranceWizardState) => {
    const accountId = immInsuranceWizardState.getIn(['steps', FOURTH_STEP, 'accountId']);
    const immAccount = immAccounts.get('byId').get(accountId);
    const accountAlias = immAccount ? immAccount.get('alias') : '';
    const accountIban = immAccount ? getLastNChars(immAccount.get('iban')) : '';
    const linkedAccount = `${accountAlias} ${accountIban}`;
    const paymentTypeText = (
        <p className="insurance-request-policy-summary__child-text">
            {linkedAccount}
        </p>
    );
    const buildAccount = {
        label: formatText('insuranceRequestHome-step5LinkedAccount'),
        text: paymentTypeText,
    }
    return buildAccount;
}

module.exports = insuranceRequestBuildAccount;